import { STUDIO_COPY } from '../config';

export type VodExpiryInput = {
  expires_at?: string | null;
  viewable_until?: string | null;
};

export type VodExpiryCountdown = {
  label: string;
  urgent: boolean;
};

/**
 * Countdown from an explicit VOD expiry timestamp only.
 * Helix / standalone list does not currently project expiry or retention,
 * so callers must pass a real timestamp — never a guessed 14-day window.
 * Returns null when unknown, unparseable, already elapsed, or zero.
 */
export function vodExpiryCountdown(
  vod: VodExpiryInput,
  now = Date.now()
): VodExpiryCountdown | null {
  const raw = (vod.expires_at || vod.viewable_until || '').trim();
  if (!raw) return null;
  const then = Date.parse(raw);
  if (Number.isNaN(then)) return null;
  const ms = then - now;
  if (ms <= 0) return null;

  const hourMs = 60 * 60 * 1000;
  const dayMs = 24 * hourMs;
  const hours = Math.ceil(ms / hourMs);
  if (hours < 24) {
    return {
      label:
        hours === 1
          ? STUDIO_COPY.expiryHourLeft
          : STUDIO_COPY.expiryHoursLeftTemplate.replace('{n}', String(hours)),
      urgent: true,
    };
  }
  const days = Math.ceil(ms / dayMs);
  return {
    label:
      days === 1
        ? STUDIO_COPY.expiryDayLeft
        : STUDIO_COPY.expiryDaysLeftTemplate.replace('{n}', String(days)),
    urgent: days < 3,
  };
}
